import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';
import { converDateWithTime } from '../../Helpers/helpers';
import {
  Button,
  Paper,
  TextField,
  List,
  ListItem,
  Divider,
  ListItemText,
  Typography,
} from '@mui/material';

export default function NotesContainer(props) {
  // console.log(relationId, '  ', relationType);
  const relationId = props.relationId;
  const relationType = props.relationType;
  const [notes, setNotes] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);
  const [currentNote, setCurrentNote] = useState('');
  const logout = GetAuth().signOut;
  const enqNotification = GetAuth().Notification;

  //Mode either get / create
  const notesEndpoint = (mode, id, relation) => {
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');

    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {};

    if (mode === 'get') {
      body['pagereq'] = {
        filter: {
          fullfilter: [
            {
              search: relation,
              field: 'relation_type',
              strict: true,
            },
            {
              search: id,
              field: 'relation_id',
              strict: true,
            },
          ],
        },
      };
      // console.log(body);
      // body['notereq'] = {
      //   relation_id: relationId,
      //   relation_type: relationType,
      // };
    } else if (mode === 'create') {
      body['note'] = {
        text: currentNote,
        relation_type: relationType,
        relation_id: relationId,
      };
    }
    const request = new Request(`${APIROOT}/api/notesv2`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });

    // console.log(request);
    // console.log(body);
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to get Notes from server`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          if (mode === 'get') {
            setNotes(parsed.data.value);
          } else {
            setForceUpdate((val) => val + 1);
          }
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : 'Connection Error',
          'error'
        );
      });
  };

  useEffect(() => {
    notesEndpoint('get', relationId, relationType);
  }, [forceUpdate, relationId, relationType]);

  //   console.log(`res is`);
  // console.log(notes);

  return (
    <>
      <Paper>
        <div style={{ padding: '15px' }}>
          <TextField
            label='Add Note:'
            multiline
            fullWidth
            value={currentNote}
            maxRows={4}
            onChange={(event) => {
              setCurrentNote(event.target.value);
            }}
          />
          <Button
            onClick={() => {
              notesEndpoint('create');
              setCurrentNote('');
            }}
          >
            Add
          </Button>
          {/* <Button
            onClick={() => {
              setForceUpdate((val) => val + 1);
            }}
          >
            Update
          </Button> */}
        </div>
        <List>
          {notes.map((key, index) => {
            return (
              <>
                <ListItem key={index} alignItems='flex-start'>
                  <ListItemText
                    sx={{
                      color: '#f50057',
                      display: 'inline',
                      // textTransform: 'capitalize',
                    }}
                    primary={converDateWithTime(key?.created)}
                    secondary={
                      <React.Fragment style={{ alignItems: 'baseline' }}>
                        <Typography
                          sx={{
                            color: '#f50057',
                            display: 'inline',
                            textTransform: 'capitalize',
                          }}
                          component='span'
                          variant='h6'
                          color='text.primary'
                        >
                          {key?.creator_name}:
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component='span'
                          variant='h6'
                          color='text.primary'
                        >
                          {' '}
                          &nbsp;
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component='span'
                          variant='body1'
                          color='text.primary'
                        >
                          {key?.text}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
              </>
            );
          })}
        </List>
        {/* <div>
          <table>
            <thead>
              <tr>
                <td>Date: </td>
                <td>Message: </td>
              </tr>
            </thead>
            <tbody>
              {notes.map((key, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <strong>{key?.created}</strong>
                    </td>
                    <td>
                      <strong>{key?.text}</strong>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div> */}
      </Paper>
    </>
  );
}
